<template>
  <UCard :ui="{ body: 'p-4 sm:p-4' }">
    <template #header>
      <h3 class="text-lg font-semibold">Setări Accesibilitate</h3>
    </template>

    <div class="space-y-4">
      <div>
        <label class="block text-sm font-medium mb-1">Font</label>
        <USelectMenu
          class="w-full"
          v-model="selectedFont"
          :items="fontOptions"
        />
      </div>

      <div>
        <label class="block text-sm font-medium mb-1">Culoare Text</label>
        <USelectMenu
          class="w-full"
          v-model="selectedTextColor"
          :items="textColorOptions"
        />
      </div>

      <div>
        <label class="block text-sm font-medium mb-1">Culoare Fundal</label>
        <USelectMenu
          class="w-full"
          v-model="selectedBgColor"
          :items="bgColorOptions"
        />
      </div>

      <div>
        <label class="block text-sm font-medium mb-1">Dimensiune Text</label>
        <USelectMenu
          class="w-full"  
          v-model="selectedTextSize"
          :items="textSizeOptions"
        />
      </div>

      <UButton @click="handleReset" color="primary" block>
        Resetează Setări
      </UButton>
    </div>
  </UCard>
</template>

<script setup lang="ts">
const {
  fontFamily,
  textColor,
  bgColor,
  textSize,
  fontOptions,
  textColorOptions,
  bgColorOptions,
  textSizeOptions,
  setFont,
  setTextColor,
  setBgColor,
  setTextSize,
  resetSettings,
  applyAccessibilitySettings
} = useAccessibility()

const selectedFont = computed({
  get: () => fontOptions.find(opt => opt.value === fontFamily.value) || fontOptions[0],
  set: (option) => setFont(option!.value)
})

const selectedTextColor = computed({
  get: () => textColorOptions.find(opt => opt.value === textColor.value) || textColorOptions[0],
  set: (option) => setTextColor(option!.value)
})

const selectedBgColor = computed({
  get: () => bgColorOptions.find(opt => opt.value === bgColor.value) || bgColorOptions[0],
  set: (option) => setBgColor(option!.value)
})

const selectedTextSize = computed({
  get: () => textSizeOptions.find(opt => opt.value === textSize.value) || textSizeOptions[0],
  set: (option) => setTextSize(option!.value)
})

const handleReset = () => {
  resetSettings()
}

onMounted(() => {
  applyAccessibilitySettings()
})
</script>